import {

  Building2, Layers, CircleDot, LandPlot, Settings, Waves
} from 'lucide-react';
import { getApiBase } from '../../lib/apiBase';

export const API = getApiBase();

export const fetchSln = (url, opts = {}) => {
  const token = localStorage.getItem('dd-token');
  const headers = { 'Content-Type': 'application/json', ...opts.headers };
  if (token) headers['Authorization'] = `Bearer ${token}`;

  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open(opts.method || 'GET', `${API}${url}`);
    Object.keys(headers).forEach(k => xhr.setRequestHeader(k, headers[k]));
    xhr.onload = () => {
      let data = {};
      try { data = JSON.parse(xhr.responseText); } catch {}
      if (xhr.status === 401) return reject(new Error('AUTH'));
      if (xhr.status === 403) return reject(new Error(data.detail || 'Trial expired. Upgrade to continue editing.'));
      if (xhr.status >= 400) return reject(new Error(data.detail || `Request failed (${xhr.status})`));
      resolve(data);
    };
    xhr.onerror = () => reject(new Error('Network error'));
    xhr.send(opts.body || null);
  });
};

export const ASSET_TYPE_META = {
  building:       { label: 'Building',           icon: Building2,  color: '#3b82f6' },
  precinct:       { label: 'Precinct',           icon: Layers,     color: '#8b5cf6' },
  tunnel:         { label: 'Tunnel',             icon: CircleDot,  color: '#f59e0b' },
  bridge:         { label: 'Bridge / Viaduct',   icon: LandPlot,   color: '#10b981' },
  retaining_wall: { label: 'Retaining Wall',     icon: Waves,      color: '#ec4899' },
  custom:         { label: 'Custom',             icon: Settings,   color: '#6b7280' },
};

export const STATUS_META = {
  ok:      { label: 'Adequate',    color: '#10b981', bg: 'rgba(16,185,129,0.12)' },
  monitor: { label: 'Monitor',     color: '#f59e0b', bg: 'rgba(245,158,11,0.12)' },
  act:     { label: 'Act Now',     color: '#ef4444', bg: 'rgba(239,68,68,0.12)' },
  unknown: { label: 'No Data',     color: '#6b7280', bg: 'rgba(107,114,128,0.12)' },
};

export const THEMES = {
  dark: {
    bg: '#080a0f', sidebar: '#0c0e14', bar: '#0f1118', card: '#12141c',
    cardBorder: 'rgba(255,255,255,0.06)', cardHover: 'rgba(255,255,255,0.03)',
    text: '#e8eaed', textMuted: '#8b8fa3', textDim: '#4a4e63',
    accent: '#10b981', accentBg: 'rgba(16,185,129,0.1)',
    inputBg: 'rgba(255,255,255,0.03)', inputBorder: 'rgba(255,255,255,0.08)',
    danger: '#ef4444', dangerBg: 'rgba(239,68,68,0.1)',
  },
  light: {
    bg: '#f5f7fa', sidebar: '#ffffff', bar: '#ffffff', card: '#ffffff',
    cardBorder: '#e5e7eb', cardHover: '#f9fafb',
    text: '#111827', textMuted: '#6b7280', textDim: '#9ca3af',
    accent: '#059669', accentBg: 'rgba(5,150,105,0.06)',
    inputBg: '#f9fafb', inputBorder: '#d1d5db',
    danger: '#dc2626', dangerBg: 'rgba(220,38,38,0.06)',
  },
};
